import { FieldArray } from "formik";
import { Box, Typography, TextField, MenuItem, IconButton } from "@mui/material";
import { AddCircle, RemoveCircle } from "@mui/icons-material";

const ApplicableTo = ({ values, setFieldValue, jobTitles }) => {
  return (
    <FieldArray
      name="applicableTo"
      render={(arrayHelpers) => (
        <Box display="flex" flexDirection="column" gap={2}>
          {values.applicableTo?.length > 0 ? (
            values.applicableTo?.map((app, index) => (
              <Box
                key={index}
                display="grid"
                gridTemplateColumns="repeat(12, 1fr)"
                gap={2}
                alignItems="center"
              >
                <TextField
                  select
                  fullWidth
                  variant="filled"
                  label="Job Titles"
                  name={`applicableTo.${index}.jobTitle`}
                  value={app.jobTitle || []}
                  onChange={(e) =>
                    setFieldValue(`applicableTo.${index}.jobTitle`, e.target.value)
                  }
                  slotProps={{ select: { multiple: true } }}
                  sx={{ gridColumn: "span 5" }}
                >
                  {jobTitles?.map((r) => (
                    <MenuItem key={r.jobTitleCode} value={r.jobTitleCode}>
                      {`${r.jobTitleCode} - ${r.description}`}
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  label="Value"
                  name={`applicableTo.${index}.value`}
                  type="number"
                  fullWidth
                  variant="filled"
                  value={app.value}
                  onChange={(e) =>
                    setFieldValue(`applicableTo.${index}.value`, e.target.value)
                  }
                  slotProps={{
                    input: {
                      sx: {
                        "& input": { textAlign: "right" },
                      },
                    },
                  }}
                  sx={{ gridColumn: "span 3" }}
                />

                <TextField
                  label="Currency"
                  name={`applicableTo.${index}.currency`}
                  select
                  fullWidth
                  variant="filled"
                  value={app.currency || "VND"}
                  onChange={(e) =>
                    setFieldValue(`applicableTo.${index}.currency`, e.target.value)
                  }
                  sx={{ gridColumn: "span 3" }}
                >
                  {["VND", "USD", "EUR", "GBP", "AUD", "JPY", "KRW"]?.map((cur) => (
                    <MenuItem key={cur} value={cur}>
                      {cur}
                    </MenuItem>
                  ))}
                </TextField>

                <Box>
                  <IconButton
                    aria-label={`remove-applicable-${index}`}
                    size="large"
                    onClick={() => arrayHelpers.remove(index)}
                    sx={{ gridColumn: "span 1" }}
                  >
                    <RemoveCircle color="error"/>
                  </IconButton>
                </Box>              
              </Box>
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No applicable items added.
            </Typography>
          )}

          <Box>
            <IconButton
              aria-label="add-applicable"
              size="large"
              color="primary"
              onClick={() =>
                arrayHelpers.push({ jobTitle: [], value: 0, currency: "VND" })
              }
            >
              <AddCircle />
            </IconButton>            
          </Box>
        </Box>
      )}
    />
  );
};

export default ApplicableTo;
